import { render, staticRenderFns } from "./CreateNewNotifTemplatesModal.vue?vue&type=template&id=4a24fd0b"
import script from "./CreateNewNotifTemplatesModal.vue?vue&type=script&lang=js"
export * from "./CreateNewNotifTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports